import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  return (
    <Card>
      <CardMedia
        component="img"
        alt="green iguana"
        height="300"
        image={product.image}
      />
      <CardContent>
        <Typography gutterBottom variant="body1">
          {product.name}
        </Typography>
        <Typography variant="body2">${product.cost}</Typography>
        <Rating name="read-only" value={product.rating} readOnly />
      </CardContent>
      <CardActions>
        <Button
          variant="contained"
          fullWidth={true}
          startIcon={<AddShoppingCartOutlined />}
          onClick={() => handleAddToCart(product._id)}
        >
          <Typography variant="body2">ADD TO CART</Typography>
        </Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;
